import React, { createContext, useContext, type ReactNode } from 'react';

export interface SessionTimeoutConfig {
  idleTimeoutMs: number;      // 60 minutes inactivity
  absoluteTimeoutMs: number;  // 8 hours maximum session
  warningMs: number;          // Warning before logout (currently not used)
}

interface SessionTimeoutContextType {
  config: SessionTimeoutConfig;
  resetTimer: () => void;
  getRemainingTime: () => number;
}

const SessionTimeoutContext = createContext<SessionTimeoutContextType | undefined>(undefined);

interface SessionTimeoutProviderProps {
  children: ReactNode;
  config: SessionTimeoutConfig;
}

export const SessionTimeoutProvider: React.FC<SessionTimeoutProviderProps> = ({ 
  children, 
  config 
}) => {
  // This is a wrapper component that provides config to useSessionTimeout hook
  // The actual idle timer logic is in useSessionTimeout hook
  
  const value: SessionTimeoutContextType = {
    config,
    resetTimer: () => {}, // Will be implemented in useSessionTimeout
    getRemainingTime: () => 0, // Will be implemented in useSessionTimeout
  };

  return (
    <SessionTimeoutContext.Provider value={value}>
      {children}
    </SessionTimeoutContext.Provider>
  );
};

export const useSessionTimeoutContext = () => {
  const context = useContext(SessionTimeoutContext);
  if (!context) {
    throw new Error('useSessionTimeoutContext must be used within a SessionTimeoutProvider');
  }
  return context;
};
